export enum ModalType {
    Approve = "approve",
    Decline = "decline"
}
